import type { ConvoyConfig } from "@air-defence-sim/sim-core";

export type ConvoyPreset = {
  id: string;
  label: string;
  description: string;
  config: Partial<ConvoyConfig>;
};

export const CONVOY_PRESETS: ConvoyPreset[] = [
  {
    id: "ambush",
    label: "Roadside ambush",
    description: "A single-axis jump from one treeline. The default scenario.",
    config: { drones: 6, axes: 1, events: 1, targeting: "concentrate", topCover: "none", standoff: 120 },
  },
  {
    id: "pincer",
    label: "Two-axis pincer",
    description: "Simultaneous launch from both sides of the road. Mutual support is cut in half.",
    config: { drones: 6, axes: 2, events: 1, targeting: "concentrate", topCover: "none", standoff: 120 },
  },
  {
    id: "swarm",
    label: "Saturation swarm",
    description: "A cheap mass attack across two events. Watch the saturation counter.",
    config: { drones: 14, axes: 2, events: 2, targeting: "spread", topCover: "none", standoff: 140 },
  },
  {
    id: "close",
    label: "Close country",
    description: "Trees almost to the verge. Warning time collapses below the reaction chain.",
    config: { drones: 5, axes: 2, events: 1, targeting: "concentrate", topCover: "none", standoff: 50 },
  },
  {
    id: "overwatch",
    label: "Armed overwatch",
    description: "The pincer again, but with an armed air layer engaging over the canopy.",
    config: { drones: 6, axes: 2, events: 1, targeting: "concentrate", topCover: "armed", standoff: 120 },
  },
  {
    id: "pack",
    label: "75-drone pack",
    description:
      "A commercial swarm pack: seventy-five drones across two pincer events. No Pk slider survives this — count the saturation events.",
    config: { drones: 75, axes: 2, events: 2, targeting: "spread", topCover: "none", standoff: 140 },
  },
];
